<template>
  <div class="live-index">
    <!-- 主页样式 -->
<!--    <div class="home-page" v-if="!liveList.length && !loading">-->
    <div class="home-page pr" v-if="!hasLive">
      <div class="header-container flex pr">
        <div class="left-box">
          <span class="company-name">- WorderCV</span><br/>
          <span class="company-tip">超级招聘</span><br/>
          <span class="company-tip">空中宣讲直播</span><br/>
          <span class="description">海量优质候选人，多人在线互动，即时数据反馈。</span>
          <div class="live-start-btn cursor_p flex" @click="toggleShowAddWechat(true)">
            <span class="font font_w_b">我要直播</span>
            <span class="iconfont iconyemiantiaozhuan" />
          </div>
        </div>
        <div class="right-box pr">
          <img class="introduce-img" src="https://files.wondercv.com/PC/hr/introduce.png" alt="">
          <span class="live-tips pa">LIVE VIDEO</span>
        </div>
      </div>
      <div class="main-container flex pr">
        <div class="item flex" v-for="(item, index) in itemList" :key="`item-${index}`">
          <img :src="item.img" alt="" class="image" :style="{'width': item.width, 'height': item.height}">
          <div class="introduce flex">
            <span class="title">{{ item.title }}</span>
            <span class="description">{{ item.description }}</span>
          </div>
          <div class="live-start-btn cursor_p font_w_b" @click="toggleShowAddWechat(true)">
            我要直播
          </div>
        </div>
      </div>
      <div class="bottom-container pr flex">
        <div class="item">
          <div class="title">千万级</div>
          <div class="description">注册用户</div>
        </div>
        <div class="item">
          <div class="title">海量</div>
          <div class="description">高质量人才</div>
        </div>
        <div class="item">
          <div class="title">扫码添加KK</div>
          <div class="description">添加客服微信了解详情</div>
        </div>
        <div class="item">
          <img src="https://files.wondercv.com/PC/hr/sanjiao.png" alt="显示二维码" class="to-qrcode" />
        </div>
        <div class="item">
          <img src="https://files.wondercv.com/hr/adv_wechat1.png" alt="客服微信" class="wechat-qrcode" />
        </div>
      </div>
      <div class="background-bottom pa" />
    </div>
    <!-- 直播列表 -->
    <div class="live-list-content" v-if="hasLive">
      <div class="content">
        <div class="page-title color_fff f_20">全部直播</div>

        <div class="live-list">
          <div class="live-item" v-for="(item, index) in liveList" :key="index">
            <div class="header clearfix t-body f_14">
              <div class="t-tr">直播主题/宣讲人</div>
              <div class="t-tr">直播时间</div>
              <div class="t-tr">
                <template v-if="liveStatus(item) === 0">实时观看人数</template>
                <template v-else-if="liveStatus(item) === 1">观看总人数</template>
                <template v-else-if="liveStatus(item) === 2">预约人数</template>
              </div>
              <div class="t-tr">&nbsp;</div>
            </div>
            <div class="info clearfix t-body f_14">
              <div class="t-tr">
                <div class="info-text ellipsis">{{ item.title }}</div>
                <div class="info-text ellipsis">{{ item.identity }}</div>
              </div>
              <div class="t-tr">
                <div class="info-text">{{ item.live_start_at ? '' : '预计' }}开始时间：{{ startAt(item) }}</div>
                <div class="info-text">{{ item.live_end_at ? '' : '预计' }}结束时间：{{ endAt(item) }}</div>
              </div>
              <div class="t-tr">
                <template v-if="liveStatus(item) === 0">{{item.view_count || 0}}</template>
                <template v-else-if="liveStatus(item) === 1">{{item.view_count || 0}}</template>
                <template v-else-if="liveStatus(item) === 2">{{item.appoint_count || 0}}</template>
              </div>
              <div class="t-tr buttons">
                <div class="button liveing" @click="toLiveDetail(item)" v-if="liveStatus(item) === 0"><span class="iconfont iconzhibozhong"></span>正在直播中…</div>
                <div class="button live-data" @click="toLiveData(item)" v-else-if="liveStatus(item) === 1">直播数据</div>
                <div class="button live-data" @click="toLiveDetail(item)" v-else-if="liveStatus(item) === 2">{{ hr_account_token === item.account_token ? '去调试' : '直播未开始' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 完善信息弹层 -->
    <tips-block v-if="tipsBlockVisible"
               tipsTitle="请完善个人信息"
               tipsText="当前个人信息不完整，完善后即可进入直播页面"
               confirmButtonText="去完善"
               @confirmFunc="toUserInfo"
               @cancelFunc="tipsBlockVisible=false" />
    <!-- 添加小助手微信 -->
    <div class="add-wechat" v-show="showAddWechat">
      <div class="bg pa" @click="toggleShowAddWechat(false)"></div>
      <div class="add-wechat-content pa text_center">
        <div class="title f_24 font_w_b">扫码添加 kk</div>
        <div class="desc1 f_14 color_40">添加客服 kk 微信了解详情</div>
        <img src="https://files.wondercv.com/hr/adv_wechat1.png" alt="kk 微信" class="qrcode">
        <div class="desc2 f_14 color_9c">扫码添加，立即了解</div>
      </div>
    </div>
  </div>
</template>
<script>
import actions from '@/actions/index'
import { mapState, mapMutations, mapActions } from 'vuex'
import { get_tUser } from '@/utils/utils';
import moment from 'moment'
//提示框样式
import TipsBlock from '@/components/block/TipsBlock'

export default {
  data(){
    return {
      liveList:[],
      loading: true,
      tipsBlockVisible: false,
      showAddWechat: false, //是否显示添加小助手微信
      hasLive: false,   // 是否有直播列表记录
      itemList: [
        {
          img: 'https://files.wondercv.com/PC/hr/zhibo_icon1%403x.png',
          title: '海量优质候选人',
          description: '千万级注册用户，高精尖人才聚集。直播讲解职位投递简历更精准',
          height: '46px',
          width: '58px'
        },
        {
          img: 'https://files.wondercv.com/PC/hr/zhibo_icon2%403x.png',
          title: '在线互动',
          description: '直播功能完善，候选人实时在线观看互动，实时预览下载附件简历',
          height: '49px',
          width: '55px'
        },
        {
          img: 'https://files.wondercv.com/PC/hr/zhibo_icon3%403x.png',
          title: '数据反馈',
          description: '记录反馈每场直播的详细数据，方便活动复盘总结',
          height: '55px',
          width: '48px'
        }
      ]
    }
  },
  created() {
    this.hasLive = this.$route.query.hasLive
    this.getUserinfo();
    this.getLiveList()
  },
  computed:{
    ...mapState('im', ['hr_account_token']),
    ...mapState('block',['userInfoState','userinfoTipsState',]),
  },
  components:{
    TipsBlock,
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState','toggleUserinfoTips',]),
    // 直播状态判断
    liveStatus(item) {
      let { start_at, end_at, live_start_at, live_end_at } = item
      // 直播已结束
      if (live_end_at) {
        return 1
        // 直播已开始未结束
      } else if (live_start_at && !live_end_at) {
        return 0
      } else {
        // 直播未开始
        return 2
      }
    },
    // 开始时间格式化
    startAt(item) {
      let date = new Date(item.live_start_at || item.start_at)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds()
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hour < 10 ? '0' + hour : hour}:${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`
      // return item.live_start_at ? moment(item.live_start_at).add(8, 'hours').format('YYYY-MM-DD hh:mm:ss') : moment(item.start_at).add(8, 'hours').format('YYYY-MM-DD hh:mm:ss')
    },
    // 结束时间格式化
    endAt(item) {
      let date = new Date(item.live_end_at || item.end_at)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds()
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hour < 10 ? '0' + hour : hour}:${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`
      // return item.live_end_at ? moment(item.live_end_at).add(8, 'hours').format('YYYY-MM-DD hh:mm:ss') : moment(item.end_at).format('YYYY-MM-DD hh:mm:ss')
    },
    // 获取直播列表
    getLiveList() {
      actions.live.getLiveList(get_tUser().h_t).then(res => {
        if (res.code === 1000) {
          let { lives } = res.data
          if (lives.length) {
            this.hasLive = true
            this.liveList = lives
          }
          // this.loading = false
        }
      })
    },
    // 直播详情页
    async toLiveDetail(item){
      //引导用户完善信息弹层
      if(!this.userInfoState){
        let user = get_tUser();
        if(user.h_t){
          await this.getUserinfo();
        }
        if(!this.userInfoState){
          //提示
          this.tipsBlockVisible = true;
          return false;
        }
      }
      window.open(`/talent/live/${item.token}`, '_blank')
      // this.$router.push(`/talent/live/${item.token}`)o 

    },
    // 直播数据页面
    async toLiveData(item){
      //引导用户完善信息弹层
      if(!this.userInfoState){
        let user = get_tUser();
        if(user.h_t){
          await this.getUserinfo();
        }
        if(!this.userInfoState){
          //提示
          this.tipsBlockVisible = true;
          return false;
        }
      }
      window.open(`/talent/live/${item.token}`, '_blank')
      // this.$router.push(`/talent/live/${item.token}`)
    },
    //更新是否完善信息(状态库)
    async getUserinfo(){
      let user = get_tUser();
      if(!user.h_t){
        return
      }
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo)
    },
    // 去完善信息页面
    toUserInfo(){
      let locationUrl = window.location.href;
      let url = encodeURIComponent(`${locationUrl}${locationUrl.substr(locationUrl.length-1,1)==='&'?'':''}`);
      window.open(`/talent/binduser?link_to=${url}` ,"_blank");
    },
    // 切换展示添加小助手微信弹窗
    toggleShowAddWechat(state){
      this.showAddWechat = state
      if(state){
        document.body.style.position = 'static'
        document.body.style.overflow = 'hidden'
      }else{
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  @import './index.scss';
  @import './list.scss';
  .live-index{
    .add-wechat{
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      .bg{
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #000000, $alpha: .5);
      }
      &-content{
        width: 340px;
        padding: 32px 0;
        background: #fff;
        border-radius: 8px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .title{
          color: #303030;
        }
        .desc1{
          line-height: 22px;
          margin: 14px 0 12px;
        }
        .qrcode{
          width: 180px;
          height: 180px;
          margin: 0 auto 18px;
        }
      }
    }
  }
</style>